<script lang="ts" setup>
type Props = {
  color?: string;
};

withDefaults(defineProps<Props>(), {
  color: "#000",
});
</script>

<template>
  <svg
    width="44"
    height="45"
    viewBox="0 0 44 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="-0.5"
      y="0.5"
      width="43"
      height="43"
      rx="21.5"
      transform="matrix(-1 0 0 1 43 0.0202637)"
      :stroke="color"
    />
    <path
      d="M14 21.2703C13.5858 21.2703 13.25 21.6061 13.25 22.0203C13.25 22.4345 13.5858 22.7703 14 22.7703L14 21.2703ZM31.0303 22.5506C31.3232 22.2577 31.3232 21.7828 31.0303 21.4899L26.2574 16.717C25.9645 16.4241 25.4896 16.4241 25.1967 16.717C24.9038 17.0099 24.9038 17.4847 25.1967 17.7776L29.4393 22.0203L25.1967 26.2629C24.9038 26.5558 24.9038 27.0307 25.1967 27.3236C25.4896 27.6165 25.9645 27.6165 26.2574 27.3236L31.0303 22.5506ZM14 22.7703L30.5 22.7703L30.5 21.2703L14 21.2703L14 22.7703Z"
      :fill="color"
    />
  </svg>
</template>
